import success from '../img/success.svg';
import error from '../img/error.svg';
import warning from '../img/warning.svg';


export const notificationImg = {
  success: {
    img: success,
    type: 'success',
  },
  error: {
    img: error,
    type: 'error',
  },
  default: {
    img: warning,
    type: 'default',
  },
};